import { Spin } from "antd";
import React from "react";
const LoadingSpinner = () => {
  return (
    <div className="loadingSpinner text-center">
      <h1>Yükleniyor...</h1>
      <Spin size="large" />
    </div>
  );
};
export default LoadingSpinner;
